import React from "react";

/**
 * The header band's refresh control: Forge's glyph in the dashboard's icon
 * button, the same one on every page that wears a PageHeader.
 *
 * It spins through CSS while `loading` (see page-header.css), where the older
 * per-page toolbars each carried their own copy of a 64-unit glyph with an
 * inline animateTransform.
 */
export default function PageHeaderRefresh({
  loading = false,
  onClick,
  title = "Refresh",
  // Optional caption drawn under the square on hover (see [data-hint] in
  // page-header.css) - the Applications band's treatment. Replaces the native
  // tooltip when given, so the name is not shown twice.
  hint,
}) {
  return (
    <div
      className="refreshButton"
      data-testid="discovery-refresh-button"
      data-loading={loading}
      role="button"
      tabIndex={0}
      aria-label={title}
      title={hint ? undefined : title}
      data-hint={hint}
      onClick={onClick}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick?.(e); } }}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12a9 9 0 0 1 15.5-6.36M21 12a9 9 0 0 1-15.5 6.36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M18.5 2.5v4.5H14M5.5 21.5V17H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}
